import {nonEmpty} from '@lib/utils';
import {Building} from '../../../data/entities';
import {UIBuildingSelectionItem} from '../types';

export const toUIBuildingSelectionItem = (building: Building): UIBuildingSelectionItem => ({
  id: building.id,
  name: building.name,
});

export const toUIBuildingSelectionItems = (buildings: Building[]): UIBuildingSelectionItem[] =>
  nonEmpty(buildings)
    .filter((building) => building.capacity > 0)
    .map(toUIBuildingSelectionItem);
